import { ReactNode } from 'react'
import DPFFeatureImg1 from '../assets/landing/DPF-feature-img-1.png'
import DPFFeatureImg2 from '../assets/landing/DPF-feature-img-2.png'
import DPFFeatureImg3PostPurchase from '../assets/landing/DPF-feature-img-3-post-purchase-modal.png'
import DPFFeatureImg3 from '../assets/landing/DPF-feature-img-3.png'

interface Feature {
  imgSrc: string
  pillText: string
  title: ReactNode
  description: ReactNode
}

const FEATURE_1: Feature = {
  imgSrc: DPFFeatureImg1,
  pillText: 'Point 1',
  title: (
    <>
      写真を選ばなくてOK!
      <br />
      みてねの思い出が自動で表示されます
    </>
  ),
  description: (
    <>
      フォトフレームのために、写真を選ぶ必要はありません。「みてね」にアップロードされた写真が、そのまま表示されます。
    </>
  ),
}

const FEATURE_2: Feature = {
  imgSrc: DPFFeatureImg2,
  pillText: 'Point 2',
  title: (
    <>
      複数アルバムの写真や動画も、
      <br />
      1台でまとめて再生
    </>
  ),
  description: (
    <>
      複数のアルバムに参加している場合は表示したいアルバムを選ぶことで、
      切り替えの手間なくまとめてスライドショー表示できます。
      <br />
      ※プレミアム契約中のアルバムのみ、すべての写真・動画が表示できます。
    </>
  ),
}

const FEATURE_3: Feature = {
  imgSrc: DPFFeatureImg3,
  pillText: 'Point 3',
  title: <>スマホからも操作できる！</>,
  description: <>スライドショーの内容変更やスリープの設定などは、みてねアプリから操作できます。</>,
}

const FEATURE_3_POST_PURCHASE: Feature = {
  imgSrc: DPFFeatureImg3PostPurchase,
  pillText: 'Point 3',
  title: <>プレゼントにもおすすめ</>,
  description: (
    <>
      離れて暮らす家族への贈り物にもぴったり。ご自身のみてねアカウントでセットアップして贈ることも、
      相手が自分のアカウントでセットアップすることもできます。
      みてねに追加された新しい写真や動画も、自動で表示されます。
      <br />
      複数アルバムの写真や動画も、1台でまとめて再生できます。
      <br />
      ※ご利用にはWi-Fiが必要です
    </>
  ),
}

function HeroTitle() {
  return (
    <h1 className='text-2xl font-semibold text-gray-12'>
      みてねの思い出を
      <br />
      もっと家族のそばに
    </h1>
  )
}

function FeatureItem({ feature }: { feature: Feature }) {
  return (
    <div className='w-full max-w-md'>
      <img
        src={feature.imgSrc}
        alt={feature.pillText}
        className='w-full rounded-lg mb-6'
        loading='lazy'
      />
      <div className='mx-auto block w-fit mb-2'>
        <span className='text-sm font-bold uppercase bg-[#F29CB2] text-white px-2 py-1 rounded-full'>
          {feature.pillText}
        </span>
      </div>
      <div className='text-center space-y-4'>
        <h2 className='text-xl font-bold text-gray-12'>{feature.title}</h2>
        <p className='text-base font-normal text-left text-gray-12 leading-[160%] tracking-0'>
          {feature.description}
        </p>
      </div>
    </div>
  )
}

export function HeroSectionForPostPurchaseModal() {
  return (
    <section className='px-4 pt-10 pb-8'>
      <div className='text-center mb-8'>
        <HeroTitle />
      </div>

      <div className='flex flex-col justify-center items-center space-y-10'>
        <FeatureItem feature={FEATURE_1} />
        <FeatureItem feature={FEATURE_2} />
        <FeatureItem feature={FEATURE_3_POST_PURCHASE} />
      </div>
    </section>
  )
}

export default function HeroSection() {
  return (
    <section className='px-4 pt-10 pb-8'>
      <div className='text-center mb-8'>
        <h2 className='text-2xl font-semibold text-gray-12'>おもいでフォトフレームの特徴</h2>
      </div>

      <div className='flex flex-col justify-center items-center space-y-10'>
        <FeatureItem feature={FEATURE_1} />
        <FeatureItem feature={FEATURE_2} />
        <FeatureItem feature={FEATURE_3} />
      </div>
    </section>
  )
}
